document.documentElement.classList.remove('no-js');
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.menu-toggle');
  if (toggle) {
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (nav) nav.classList.toggle('is-open', !expanded);
  }
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (minus || plus) {
    const input = event.target.closest('.quantity').querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
  }
});
document.addEventListener('change', (event) => {
if (!event.target.matches('[data-option-position]')) return;
  const formWrap = event.target.closest('[data-product-form]');
  if (!formWrap) return;
  const script = formWrap.querySelector('[data-product-variants]');
  const input = formWrap.querySelector('[data-variant-id]');
  const submit = formWrap.querySelector('[type="submit"]');
  if (!script || !input) return;
  const selected = Array.from(formWrap.querySelectorAll('[data-option-position]:checked')).sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map(i=>i.value);
  const variants = JSON.parse(script.textContent);
  const variant = variants.find(v => v.options.every((o,i)=>o===selected[i]));
  if (!variant) return;
  input.value = variant.id;
  if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
});

